import React from 'react';
import { Markdown } from '../Util/Markdown/Markdown';
import { useTranslation } from '../../lang/useTranslation';

export const Dashboard = () => {
    const message = useTranslation('literal.CustomLiterals.Dashboard.Message', {});

    return <Markdown>{message}</Markdown>;
};
